import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { SiteModel } from '@core/model/site.model';
import { utiles } from '@utl/environment';
import { UserModel } from '@core/model/user.model';
import { MasterClientModel } from '@core/model/masterClient.model';
import { CommonService } from './common.service';
import { Injectable } from "@angular/core";
/*Constants */
const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

@Injectable()
export class SettingService {

  constructor(public http: HttpClient, private router: Router, private common: CommonService) {
    let data = utiles.getCacheUser();
    if (data !== null && data !== undefined) {
    } else {
      this.common._setLoading(false);
      this.router.navigate(['login']);
    }
  }

  getUsersAndAccountsFromAdmin(model: any) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'GetUsersAndAccountsFromAdmin';
    return this.http.post<any>(url, model, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  deleteAccountFromUser(model: any) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'DeleteAccountFromUser';
    return this.http.post<any>(url, model, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  GetUsersToRegisterFromAdmin(model: any) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'GetUsersToRegisterFromAdmin';
    return this.http.post<any>(url, model, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  insertAccountUser(model: any) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'InsertAccountUser';
    return this.http.post<any>(url, model, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }
}

